document.addEventListener('DOMContentLoaded', function() {
  const currentHost = window.location.hostname;

  function setExternalTargets() {
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  }

  // Run once on load
  setExternalTargets();

  // Watch for dynamically added links (Horizon's modular JS)
  const observer = new MutationObserver(setExternalTargets);
  observer.observe(document.body, { childList: true, subtree: true });
});

